<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/mxBjDL/tc-custom/9781646566464.jpg?1723374916883" alt="This image is the cover for the book Lies of Omission"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Lies of Omission
      </h1>
      <p class="bookDescription body article font2">
        <p>Lyle Atwood's company is hired to costume a party given by multi-millionaire Warner Radclyffe. As he and his employees begin preparations for the job, Lyle begins to feel as if someone is watching him. Then he meets Damien Sauvage, the newest tenant in the apartment building where he lives.<br/><br/>Damien tells Lyle that he's a waiter, and when Lyle confides in him that he thinks he's being stalked, Damien offers to help find out who it is. What he neglects to tell Lyle is he actually works for Radclyffe, who wants him to protect Lyle from a very powerful enemy.<br/><br/>As Damien gains Lyle's confidence, he becomes attracted to the younger man -- an attraction that Lyle reciprocates. He fights his feelings, knowing Lyle will hate him when he finds out his secret -- and even more so when he learns what Damien really is.<br/><br/>Radclyffe orders Damien to continue the job, as he has a secret of his own involving Lyle. A secret that cannot be revealed until the night of the party.<br/><br/>Can Lyle survive what is to come, or will the lies of omission be the death of him -- or worse?</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Edward Kendrick
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?1bb7039c